import { useQuery } from "@tanstack/react-query";
import { apiFetch } from "../api/client.js";

export interface RepoRefs {
  readonly branches: string[];
  readonly tags: string[];
  /**
   * The branch to use when a caller has no ref of its own. Resolved server-side
   * against what the repo actually contains, so it is never a branch that was
   * recorded at creation but never created (`main` on a repo whose first push
   * went to `arch/…`). Absent only on an empty repo.
   */
  readonly defaultBranch?: string;
}

export function useRepoRefs({ slug, repo }: { slug: string; repo: string }) {
  return useQuery({
    queryKey: ["repo-refs", slug, repo],
    // Via apiFetch so a 401 triggers the sign-in redirect instead of a bare
    // "refs failed" (bugloop L3).
    queryFn: ({ signal }): Promise<RepoRefs> =>
      apiFetch<RepoRefs>(
        `/api/ws/${encodeURIComponent(slug)}/r/${encodeURIComponent(repo)}/refs`,
        { signal },
      ),
    staleTime: 60 * 1000,
  });
}
